'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SpruceClassName = require('../util/SpruceClassName');

var _SpruceClassName2 = _interopRequireDefault(_SpruceClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module Inputs
 */

/**
 * @component
 *
 * `Input` is a simple component that displays an input.
 * It does not keep state.
 *
 * @example
 * return <Input type='text' onChange={(val) => doStuff(val)}/>
 */

var Input = function (_React$Component) {
    (0, _inherits3.default)(Input, _React$Component);

    function Input() {
        (0, _classCallCheck3.default)(this, Input);
        return (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).apply(this, arguments));
    }

    (0, _createClass3.default)(Input, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                disabled = _props.disabled,
                inputProps = _props.inputProps,
                modifier = _props.modifier,
                name = _props.name,
                onChange = _props.onChange,
                peer = _props.peer,
                spruceName = _props.spruceName,
                style = _props.style,
                type = _props.type,
                value = _props.value,
                placeholder = _props.placeholder;


            return _react2.default.createElement('input', (0, _extends3.default)({
                disabled: disabled,
                name: name,
                placeholder: placeholder,
                type: type
            }, inputProps, {
                className: (0, _SpruceClassName2.default)({ name: spruceName, modifier: modifier, className: className, peer: peer }),
                onChange: function (_onChange) {
                    function onChange(_x) {
                        return _onChange.apply(this, arguments);
                    }

                    onChange.toString = function () {
                        return _onChange.toString();
                    };

                    return onChange;
                }(function (ee) {
                    return onChange && onChange(ee.target.value, { event: ee, element: ee.target });
                }),
                value: value == null ? '' : value,
                style: style
            }));
        }
    }]);
    return Input;
}(_react2.default.Component);

Input.defaultProps = {
    className: '',
    disabled: false,
    inputProps: {},
    modifier: '',
    peer: '',
    spruceName: 'Input',
    style: {},
    type: 'text',
    value: ''
};
exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./~/stampy/lib/component/Input.js
// module id = 151
// module chunks = 35783957827783 114276838955818 162898551421021